<template>
    <div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                component_name: '',
            }
        },
        created() {
            this.component_name = this.$route.query.component_name || ''
            if(this.component_name) {
                this.$router.push({
                    name: this.component_name
                })
            }else {
                this.$router.push('/')
            }
        }
    }
</script>